<script setup>
import { useRouter } from "vue-router/composables";
import Loader from "@/components/Tools/Loader.vue";
import { ref, onMounted, onUnmounted } from "vue";
import JwtService from "@/core/services/jwt.service";
import ApiService from "@/core/services/api.service";
import { getExpectedOrigin } from "@/components/IFrame/iframehelper";

const router = useRouter();

const isWaitingForToken = ref(true);
const isTokenReceived = ref(false);
const isAuthenticating = ref(false);

async function handlePostMessage(event) {
  if (event.data?.type === "INSTANCE_AUTH_TOKEN" && event.data?.token) {
    isTokenReceived.value = true;
    isWaitingForToken.value = false;
    isAuthenticating.value = true;

    try {
      JwtService.saveToken(event.data.token);
      ApiService.init();
      // Give the token a moment to be stored
      await new Promise(resolve => setTimeout(resolve, 200));

      if (router.currentRoute.query.flow_id) {
        await router.push({
          name: "projectWorkflowsEditor",
          params: { id: router.currentRoute.query.flow_id }
        });
        return;
      }

      await router.push({ name: "projectWorkflows" });
    } catch (error) {
      // Redirect to normal login on error
      await router.push({ name: "login" });
    }
  }
}

onMounted(() => {
  // Send ready message to parent window
  try {
    if (window.opener) {
      // Send message for management app
      window.opener.postMessage(
        { type: "INSTANCE_WINDOW_READY" },
        process.env.VUE_APP_MANAGEMENT_URL
      );
      const v2FrontendUrl = getExpectedOrigin();
      // Send message for v2 frontend
      window.opener.postMessage(
        { type: "INSTANCE_WINDOW_READY" },
        v2FrontendUrl
      );
    }
  } catch (error) {
    //
  }

  // Set a timeout to redirect to login after 10 seconds
  setTimeout(() => {
    if (!isTokenReceived.value) {
      router.push({ name: "login" });
    }
  }, 10000);

  // Listen for postMessage events
  window.addEventListener("message", handlePostMessage);
});

onUnmounted(() => {
  window.removeEventListener("message", handlePostMessage);
});
</script>

<template>
  <div>
    <Loader />
    <div class="container text-center mt-10">
      <h3>
        {{
          isAuthenticating
            ? $t("general.authenticating")
            : $t("general.waitingForAuthentication")
        }}
      </h3>
      <p>
        {{
          isAuthenticating
            ? $t("general.settingUpSession")
            : $t("general.authWaitMessage")
        }}
      </p>
    </div>
  </div>
</template>

<style></style>
